import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {CommonValidators} from '../../shared/common-components/common-validators';
import {ActivatedRoute} from '@angular/router';
import {DataService} from '../../services/data.service';
import {UserProfileService} from 'src/app/services/user-profile/user-profile.service';
import {UserService} from '../../services/user/user.service';
import {takeWhile, BehaviorSubject} from 'rxjs';
import {User} from '../../services/user/user';

@Component({
    selector: 'app-account-info',
    templateUrl: './account-info.component.html',
    styleUrls: ['./account-info.component.css'],
    standalone: false
})
export class AccountInfoComponent implements OnInit, OnDestroy {
  accountInfoForm: UntypedFormGroup;
  saveSuccessful = false;
  disabled = true;
  user: any = null;
  securityQuestion: any;
  securityAnswer: any;
  showAnswer: boolean;
  errorMessage: string = null;
  sucessMessage: string = null;
  isContainApps: boolean;
  containAppsMessage: string = null;
  saveError: boolean;
  oktaUserApplications: any = null;
  private observer$ = new BehaviorSubject(true);
  currentUser: User;
  tmssLoader: any;

  constructor(private userProfileService: UserProfileService,
              private fb: UntypedFormBuilder,
              private alertService: AlertService,
              private dataService: DataService,
              private route: ActivatedRoute,
              private loader: LoadingService, private userService: UserService) {
    this.tmssLoader = this.loader;
    const passwordFormControl: UntypedFormControl = new UntypedFormControl('', Validators.required);
    this.accountInfoForm = this.fb.group({
      phone: new UntypedFormControl('', Validators.required),
      email: new UntypedFormControl('', [Validators.required, CommonValidators.email, CommonValidators.specialEmail]),
      currentPassword: [null, [Validators.required]],
      newPassword: passwordFormControl,
      confirmPassword: new UntypedFormControl('', [Validators.required, CommonValidators.same(passwordFormControl)]),
      securityQuestion: [null],
      securityAnswer: [null]
    });
  }

  numericsOnly(c: UntypedFormControl) {
    const phone = /^[0-9]*$/;
    return phone.test(c.value) ? null : {
      numericsOnly: {
        valid: false
      }
    };
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['userId']) {
        this.loadAcctInfo(params);
      } else {
        this.disabled = false;
      }
    });
    this.accountInfoForm.valueChanges.subscribe(formData => {
      this.saveSuccessful = false;
      this.saveError = false;
    });
    this.userService.getCurrentUserObservable()
      .pipe(takeWhile(() => this.observer$.value)).subscribe((currentUser: any) => {
      this.currentUser = currentUser;
    }, (error) => {
      this.tmssLoader.hide();
    });
  }

  loadAcctInfo(params) {
    this.containAppsMessage = null;
    this.isContainApps = false;
    this.tmssLoader.show();
    this.userProfileService.getUserOkta(params['userId']).subscribe(oktaUserApplications => {
      this.oktaUserApplications = oktaUserApplications;
      this.user = oktaUserApplications.userEntity;
      if (this.oktaUserApplications.oktaApps != null) {
        const index = this.oktaUserApplications.oktaApps.findIndex(okatApp => okatApp === 'TMSS');
        if (index > -1) {
          this.oktaUserApplications.oktaApps.splice(index, 1);
        }
        if (this.oktaUserApplications.oktaApps.length > 0) {
          this.containAppsMessage = 'User got access to following apps: ' + this.oktaUserApplications.oktaApps;
          this.isContainApps = true;
        }
      }
      this.accountInfoForm.get('phone').setValue(this.user.phone);
      this.accountInfoForm.get('email').setValue(this.user.email);
      this.tmssLoader.hide();
    }, (error) => {
      this.tmssLoader.hide();
      this.alertService.error('There was an error retrieving User Info');
    });
  }

  updatePassword() {
    this.tmssLoader.show();
    const accountInfoForm = this.accountInfoForm;
    this.user.email = accountInfoForm.value.email;
    this.user.oldPassword = accountInfoForm.value.currentPassword;
    this.user.newPassword = accountInfoForm.value.newPassword;
    this.user.secretQuestion = null;
    this.user.secretAnswer = null;
    this.userProfileService.updateOKTA(this.user).subscribe(user => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully Updated the profile');
        this.sucessMessage = 'Your password has been updated sucessfully. Please use the new password to login to all other apps in OKTA';
        this.accountInfoForm.get('currentPassword').setValue(null);
        this.accountInfoForm.get('newPassword').setValue(null);
        this.accountInfoForm.get('confirmPassword').setValue(null);
        window.scrollTo(0, 0);
        this.saveSuccessful = true;
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving user account info', error);
        this.errorMessage = JSON.parse(JSON.stringify(error.error));
        this.saveError = true;
        this.saveSuccessful = false;
        window.scrollTo(0, 0);
      });
  }

  updateConfirmPwd() {
    if (this.accountInfoForm.value.newPassword === '') {
      this.accountInfoForm.get('confirmPassword').setValue(null);
    }
  }

  changeQuestion() {
    this.securityQuestion = this.accountInfoForm.get('securityQuestion').value;
    this.securityAnswer = this.accountInfoForm.get('securityAnswer').value;
    this.accountInfoForm.get('securityAnswer').setValue(null);
    if (this.securityQuestion === 'null') {
      this.showAnswer = false;
    } else {
      this.showAnswer = true;
    }
    return this.securityQuestion;
  }

  updateSecurityQn() {
    this.tmssLoader.show();
    const accountInfoForm = this.accountInfoForm;
    this.user.email = accountInfoForm.value.email;
    this.user.oldPassword = null;
    this.user.newPassword = null;
    this.user.secretQuestion = accountInfoForm.value.securityQuestion;
    this.user.secretAnswer = accountInfoForm.value.securityAnswer;
    this.userProfileService.updateOKTA(this.user).subscribe(user => {
        this.tmssLoader.hide();
        this.alertService.success('Successfully Updated the profile');
        this.sucessMessage = 'Your Security Question and Answer have been updated sucessfully. Please note that this change will update your profile in OKTA';
        this.accountInfoForm.get('securityQuestion').setValue(null);
        this.accountInfoForm.get('securityAnswer').setValue(null);
        window.scrollTo(0, 0);
        this.saveSuccessful = true;
      },
      error => {
        this.tmssLoader.hide();
        this.alertService.error('Error while saving user account info', error);
        this.errorMessage = JSON.parse(JSON.stringify(error.error));
        this.saveError = true;
        this.saveSuccessful = false;
        window.scrollTo(0, 0);
      });
  }

  ngOnDestroy(): void {
    this.observer$.next(false);
  }

}
